
import MSInfoItem from "@/components/setting/MSInfoItem.vue";
import MSReflectionDisplayModal from "@/components/MSReflectionDisplayModal.vue";
import store from "@/store";
import { Options, Vue } from "vue-class-component";
import { awaitStudentLoaded } from "@/store/index";
import { Student } from "@/entities/student";
import { Unit, unitCollectionKey, convertToUnit } from "@/entities/reflection";
import firebase from "firebase/app";
import { schoolConfigCollectionKey } from "@/entities/school";
import MButton from "@/components/form/MButton.vue";

@Options({
  components: {
    MSInfoItem,
    MSReflectionDisplayModal,
    MButton
  }
})
export default class LearningCard extends Vue {
  student: Student | null = null;
  unit: Unit | null = null;
  units: Unit[] = [];
  loading = false;
  isDisplayModalOpen = false;

  // TODO: 後で調整
  get hasPolarDeviceid(): boolean {
    return false;
  }

  get translatedValue() {
    return store.state.translatedValue;
  }

  openDisplayModal(unitId: string) {
    const targetUnit = this.units.find(_ => _.ref.id === unitId);
    if (!targetUnit) {
      // 通常ありえない
      alert("指定の単元が見つかりません。");
      return;
    }
    this.unit = { ...targetUnit };
    this.isDisplayModalOpen = true;
  }

  closeDisplayModal() {
    this.isDisplayModalOpen = false;
    this.unit = null;
  }

  handleAiReflectionUpdate(result: { unitId: string; content: string }) {
    if (!this.unit) return;
    if (!result.unitId) return;
    if (this.unit.data.uid !== result.unitId) return; //普通あり得ない
    const { unitId, content } = result;
    this.unit.data.aiReflection = content;
    this.units = this.units.map(u =>
      u.data.uid === unitId ? ({ ...this.unit } as Unit) : ({ ...u } as Unit)
    );
  }

  async isValidUser(
    student: Student | null
  ): Promise<{
    isValid: boolean;
    error: string | null;
    unitsSnapshot?: firebase.firestore.QuerySnapshot<
      firebase.firestore.DocumentData
    >;
  }> {
    let error = "";
    if (!student) {
      error = "生徒情報が正しくありません。";
      return { isValid: false, error };
    }

    const schoolDocId = student.ref.parent.parent?.parent?.parent?.id;
    if (!schoolDocId) {
      error = "スクールが見つかりません";
      return { isValid: false, error };
    }

    const [unitsSnapshot, schoolConfigSnapshot] = await Promise.all([
      student.ref.collection(unitCollectionKey).get(),
      firebase
        .firestore()
        .collection(schoolConfigCollectionKey)
        .doc(schoolDocId)
        .get()
    ]);

    const canUseLearningCard = !!(
      schoolConfigSnapshot.exists &&
      schoolConfigSnapshot.data()?.canUseLearningCard
    );

    return {
      isValid: canUseLearningCard,
      error: canUseLearningCard ? null : "権限がありません。",
      unitsSnapshot
    };
  }

  async created() {
    this.loading = true;
    this.student = (await awaitStudentLoaded(store)) as Student;

    try {
      store.commit("SET_LOADING", true);
      store.commit("SET_LOAD_TEXT", "情報取得中...");

      const { error, unitsSnapshot, isValid } = await this.isValidUser(
        this.student
      );

      if (!isValid || error || !unitsSnapshot) {
        throw new Error(error || "ユーザー情報が正しくありません。");
      }

      this.units = !unitsSnapshot.empty
        ? unitsSnapshot.docs
            .filter(doc => doc.exists && doc.data())
            .map(doc => convertToUnit(doc.data(), doc.ref))
        : [];
    } catch (e) {
      alert("情報の取得に失敗しました。" + "\n" + e);
      console.error(e);

      window.location.href =
        store.state.schoolAIBaseUrl || "https://school-ai-app.mingaku.net/"; //念のために本番URLにフォールバック
    } finally {
      store.commit("SET_LOADING", false);
      store.commit("SET_LOAD_TEXT", "");
      this.loading = false;
    }
  }
}
